"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAsyncData = useAsyncData;

var _react = require("react");

function useAsyncData(dataFunction, refreshOn) {
  const [result, setResult] = (0, _react.useState)(null);
  const [loading, setLoading] = (0, _react.useState)(true);
  const [error, setError] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    function run() {
      setLoading(true);
      setError(null);
      dataFunction().then(value => {
        setLoading(false);
        setResult(value);
        setError(null);
      }).catch(err => {
        setLoading(false);
        setResult(null);
        setError(String(err));
      });
    }

    run();
  }, refreshOn || []);
  return {
    result,
    loading,
    error
  };
}
//# sourceMappingURL=useAsyncData.js.map